import { useContext } from "react";

import { MapContext } from "../contexts/MapContext";

export function useMapContext() {
  const context = useContext(MapContext);
  if (context === undefined) {
    throw new Error("useContext must be within a Map provider");
  }
  return context;
}

/**
 * Safe version of useMapContext that returns undefined instead of throwing
 * when used outside a Map provider. Use this for components that can optionally
 * integrate with MapContext.
 */
export function useMapContextSafe() {
  return useContext(MapContext);
}
